module.exports = __webpack_public_path__ + "img/2_198.83cb6e30.png";